import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { ModalController, ToastController } from "@ionic/angular";

@Component({
  selector: "appeal-reject-case",
  templateUrl: "./appeal-reject-case.component.html",
})
export class AppealRejectComponent implements OnInit {
  rejectForm: FormGroup = new FormGroup({});
  pan: string;
  applicantName: string;

  constructor(
    private modalCtrl: ModalController,
    private toastController: ToastController
  ) {}

  ngOnInit(): void {
    this.rejectForm = new FormGroup({
      rejectReason: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(3500),
      ]),
    });
  }

  async showErrorToast(errorMessage: string) {
    const toast = await this.toastController.create({
      message: errorMessage,
      icon: "information-circle",
      position: "top",
      duration: 2000,
    });
    toast.present();
  }

  async ngSubmit() {
    console.log("this.rejectForm");
  }
  handleKeyPress(event: KeyboardEvent): void {
    const textarea = event.target as HTMLTextAreaElement;
    const cursorPosition = textarea.selectionStart;
    if (cursorPosition === 0 && event.key === " ") {
      event.preventDefault();
    }
  }
  reject() {
    console.log("this.rejectForm", this.rejectForm.value.rejectReason);
    if (!this.rejectForm.value.rejectReason) {
      this.showErrorToast("Please Enter Reject Reason");
    }

    if (this.rejectForm.valid) {
      return this.modalCtrl.dismiss(
        this.rejectForm.value.rejectReason,
        "reject"
      );
    }
  }

  cancel() {
    return this.modalCtrl.dismiss(null, "cancel");
  }
}
